import React from 'react'
import ServiceGiftTemplate from '../../../components/template/ServiceGiftTemplate/ServiceGiftTemplate'
import PropTypes from 'prop-types'
import { getApiClient } from '../../../utils'
import { PAGINEDETAIL } from '../../../utils/endpoint'

const ServiceGift = ({ page }) => {
  return (
    <>
      <ServiceGiftTemplate page={page} />
    </>
  )
}

export async function getServerSideProps({ locale, req }) {
  const api = getApiClient(req)
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'service-gift',
        lang: locale,
      },
    })
    const page = await pageResponse.data

    const toolbarProps = { toolbarPage: page }

    return { props: { page, ...toolbarProps } }
  } catch (error) {
    return {
      notFound: true,
    }
  }
}

ServiceGift.propTypes = {
  page: PropTypes.object,
}

export default ServiceGift
